
import styled from 'styled-components';
import ReportVoiceHeader from './components/ReportVoiceHeader';
import ReportVoiceTable from './components/ReportVoiceTable';
import useGetReportVoice from '../../services/hooks/useGetReportVoice';

const ReportVoicePage = () => {
  const { data, params, setParams } = useGetReportVoice();
  return (
    <Container>
        <ReportVoiceHeader params={params} setParams={setParams} />
        <ReportVoiceTable data={data} params={params} setParams={setParams} />
    </Container>
  );
};

export default ReportVoicePage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 1.5rem;
`;
